import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import JobTypeSearch from 'modules/job-types/components/JobTypeSearch';

import Banner from './Banner';

import styles from './BannerJobTypeSearch.module.scss';

interface Props {
  bgImg: string;
  subtitle: string;
  title: string;
}

const BannerJobTypeSearch: FC<Props> = ({ bgImg, subtitle, title }) => {
  const { t } = useTranslation();

  return (
    <Banner bgImg={bgImg} alt={title}>
      <div className={styles.content}>
        <h1 className={styles.title}>{title}のプロと出会う。</h1>
        <p className={styles.subtitle}>{subtitle}</p>
        <div className={styles.job}>
          <JobTypeSearch
            buttonText={t('jobTypeSelect.searchPro')}
            id="bannerJobTypeSearch"
            isButtonAnimated={true}
          />
        </div>
      </div>
    </Banner>
  );
};

export default BannerJobTypeSearch;
